export default __webpack_public_path__ + "static/napoleon_hill-46a3c423c5320a67c1de91089b0831da.jpg";